import { logUtil } from 'packages/src'
import { updateObjectReduxReducerUtil } from './utils/update-object'

/**
 * @param {State} state
 * @param {updateReduxActionProps} action
 * @returns {*|string}
 */
export function updateReduxReducer (state, action) {
  const { payload } = action
  const {
    paths,
    updates,
    isLocal
  } = payload

  // If it's an array, update every element
  if (paths && !updates) {
    logUtil('updateReduxReducer').warn('[noop] updates not provided with action=', action)
    return state
  }

  if (paths) {
    return paths.reduce((updatedState, path, index) => {
      return updateObjectReduxReducerUtil(updatedState, {
        ...payload,
        path,
        updates: updates[index],
        isLocal
      })
    }, state)
  }

  return updateObjectReduxReducerUtil(state, payload)
}
